import React from 'react'
import { DateKey } from '../../types/DateKey'
import { styled } from '../../stitches/stitches.config'
import {
  getCurrentMonth,
  getCurrentYear,
  getDateKeysRecentNDays,
  toDayName,
  toDate,
} from '../../utils/date'
import { toLocationGroupName } from '../../api/identify'

type Props = {
  groupCode: string
  selectedDateKey: DateKey
  onDateKeyCange: (date: DateKey) => void
}

const PageFeedWeekCalendar: React.FC<Props> = ({
  groupCode,
  selectedDateKey,
  onDateKeyCange,
}) => {
  const recentSevenDateKeys = getDateKeysRecentNDays(7)

  return (
    <>
      <Title>{`${getCurrentYear()}년 ${getCurrentMonth()}월  ${String.fromCharCode(
        0x00b7
      )}  ${toLocationGroupName(groupCode)}`}</Title>
      <WeekCalendar>
        {recentSevenDateKeys.map((dateKey, i) => {
          const date = toDate(dateKey)
          const handleClick = () => {
            onDateKeyCange(dateKey)
          }

          return (
            <Day key={i} onClick={handleClick}>
              <KoreanDayName>{toDayName(date.getDay())}</KoreanDayName>
              <DateNumber
                state={selectedDateKey === dateKey ? 'active' : 'deactive'}
              >
                <div>{date.getDate()}</div>
              </DateNumber>
              {i === 6 && <Marker>오늘</Marker>}
            </Day>
          )
        })}
      </WeekCalendar>
    </>
  )
}

export default PageFeedWeekCalendar

const Title = styled('div', {
  $text: 'title',
  padding: '0 0 0 16px',
  whiteSpace: 'pre',
})

const WeekCalendar = styled('div', {
  display: 'flex',
  padding: '24px 32px 32px',
  justifyContent: 'space-between',
})

const Day = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  WebkitTapHighlightColor: 'transparent',
  width: '10%',

  '&:active': {
    outline: 'none',
    WebkitTapHighlightColor: 'transparent',
  },
})

const KoreanDayName = styled('div')

const DateNumber = styled('div', {
  margin: '16px 0 0',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: '100%',
  aspectRatio: '1 / 1',
  fontSize: '14px',
  textAlign: 'center',

  variants: {
    state: {
      active: {
        background: 'white',
        borderRadius: '50%',
        color: '$background',
        fontWeight: 'bold',
      },
      deactive: {
        color: '$gray300',
      },
    },
  },
})

const Marker = styled('div', {
  margin: '8px 0 0',
  $text: 'label',
})
